import { PLAN_SELECTOR_ELEMENT_ID, PLAN_SELECTOR_ROOT_ID } from '@/lib/branchTypes'

// Tags only the top-level plan-selector grid so other UI can scroll/anchor to it.
export const resolveBranchChoiceDomId = (nodeId: string) => {
  if (nodeId !== PLAN_SELECTOR_ROOT_ID) return undefined
  return PLAN_SELECTOR_ELEMENT_ID
}
